import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import { Header } from '@intuginetech/intureact';
import './Navbar.css';
import LogoutCard from './LogoutCard';
import MenuCard from './MenuCard';
import { IconButton as MuiIconButton , Grid, Menu as MuiMenu, MenuItem} from '@mui/material';
import Bell from '../common/Icons/Bell'
import Menu from '../common/Icons/Menu'
import Avatar from '@mui/material/Avatar'
import ChevronDown from '../common/Icons/ChevronDown'
import Box from '../common/Box/Box'
import { useNavigate, useLocation } from 'react-router-dom';
// import AppBar from './appBar';
import SideNav from './SideNav';
import { useValidateTokenMutation } from '../../store/apiSlice';
import { useConfig } from '../../hooks/useConfig';
import PaymentReminderDialog from '../common/PaymentReminderDialog';
import moment from 'moment';
import { useProductConfig } from '../../context/ProductConfigContext';
// import { 
//   shouldShowPaymentReminder, 
//   markPaymentReminderShown, 
//   extractPaymentDetails, 
//   hasPendingPayment 
// } from '../../utils/paymentReminderUtils';

// get mobile nav items from items array
const getMobileNavItems = (items) => {
  return [...items].concat(...items.filter(item=> item.dropdown).map(item => item.dropdown_items)).filter(item=> !item.dropdown)
}

const Navbar = ({ items ,handleStorageChange}) => {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)
  const [menuCardData, setMenuCardData] = useState([])
  const [logAnchorEl, setLogAnchorEl] = useState(null)
  const [showMenuCard, setShowMenuCard] = useState(false)
  const [showNarcissism, setShowNarcissism] = useState(false)
  const [platformName, setPlatformName] = useState('IntuTrack')
  const [anchorEl, setAnchorEl] = useState(null)
  const [mobileView, setMobileView] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [logoUrl, setLogoUrl] = useState('/assets/images/intugine-logo.svg')
  const [navItems, setNavItems] = useState(items)
  const [mobileNavItems, setMobileNavItems] = useState(getMobileNavItems(items))
  const [showPaymentReminder, setShowPaymentReminder] = useState(false)
  const [dropdownAnchorEl, setDropdownAnchorEl] = useState({}) // Object to store anchor elements for each dropdown
  // const [paymentDetails, setPaymentDetails] = useState(null)
  const navigate = useNavigate();
  const [validateToken] = useValidateTokenMutation();
  const location = useLocation();
  const { config } = useConfig();
  const { featureConfig } = useProductConfig();

  const handleLogClose = () => {
    setLogAnchorEl(null)
  }
  const handleMenuClose = () => {
    setMenuAnchorEl(null)
  }
  const handleClickMenu = (e) => {
    setMenuAnchorEl(e.currentTarget)
  }
  const handleClickLogout = (e) => {
    setLogAnchorEl(e.currentTarget)
  }
  const handleClick = (e) => {
    setAnchorEl(e.currentTarget)
    // dispatch(getNotifications())
  }
  
  const handleDropdownOpen = (e, dropdownId) => {
    setDropdownAnchorEl(prev => ({
      ...prev,
      [dropdownId]: e.currentTarget
    }));
  }
  
  const handleDropdownClose = (dropdownId) => {
    setDropdownAnchorEl(prev => {
      const newState = { ...prev };
      delete newState[dropdownId];
      return newState;
    });
  }
  
  // Move the narcissism state update to useEffect
  useEffect(() => {
    if (config?.show_narcissism !== undefined || featureConfig?.white_label?.show_narcissism !== undefined) {
      setShowNarcissism(config?.show_narcissism || featureConfig?.white_label?.show_narcissism);
    }
  }, [config?.show_narcissism,featureConfig?.white_label?.show_narcissism]);

  useEffect(() => {
    if(config?.brand?.logo)
      setLogoUrl(getLogo(config?.brand?.logo))
    if(featureConfig?.white_label?.brand?.logo)
      setLogoUrl(getLogo(featureConfig?.white_label?.brand?.logo))
  }, [config?.brand?.logo, featureConfig?.white_label?.brand?.logo]);

  const logo = () => {
    let url = "/assets/images/intugine-logo.svg"
    if(config?.logo?.url)
      url = getLogo(config?.logo?.url)
    if(featureConfig?.white_label?.logo?.url)
      url = getLogo(featureConfig?.white_label?.logo?.url)

    const hideLogo = config?.hide_logo || featureConfig?.white_label?.hide_logo === true
    if(hideLogo)
      return null
    
    return(<><img src={url} alt="logo" className="logo" style={{ height: '45px', width: "auto"}}/></>)
  }

  const handleMobileMenuOpen = () => {
    setMobileMenuOpen(true)
    console.log("mobileMenuOpen",mobileMenuOpen)
  }
  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false)
    console.log("set handleMobileMenuClose",mobileMenuOpen)
  }

  useEffect(() => {
    const handleResize = () => {
      setMobileView(window.innerWidth <= 768)
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => { 
    setMobileNavItems(getMobileNavItems(items))
    setNavItems(items);
    
  }, [items]);

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      validateToken({ token }).unwrap()
        .then((response) => {
        // Check for pending payment and show reminder if needed
          if (response?.account?.pending_payment) {
            let today = moment().format("DD-MM-YYYY")
            let alertDate = localStorage.getItem('payment_alert');
            if(alertDate !== today){
              localStorage.setItem('payment_alert', today);
              setShowPaymentReminder(true);
            }
            // setShowPaymentReminder(true);
          }
        })
        .catch(() => {
          navigate('/logout');
        });
    }
  }, [validateToken, location]);

  const getLogo = (url) => {
    return url.replace("https://assetsstatic.s3.ap-south-1.amazonaws.com","https://staticassests.intusystems.info")
  }

  // Highlight active navbar item based on current route
  const normalizePath = (p = '') => (p.endsWith('/') ? p.slice(0, -1) : p);
  const splitPathAndQuery = (p = '') => {
    const [pathnamePart = '', queryStringPart = ''] = String(p).split('?');
    return { pathname: normalizePath(pathnamePart), queryString: queryStringPart };
  };
  const isRouteActive = (path = '') => {
    const currentPath = normalizePath(location?.pathname || '');
    const { pathname: targetPath, queryString } = splitPathAndQuery(path);

    if (!targetPath) return false;

    const pathMatches = currentPath === targetPath || currentPath.startsWith(`${targetPath}/`);
    if (!pathMatches) return false;

    // If the target includes query (ex: /page?id=module), match those params too.
    if (queryString) {
      const targetParams = new URLSearchParams(queryString);
      const currentParams = new URLSearchParams(location?.search || '');
      return [...targetParams.entries()].every(([key, value]) => currentParams.get(key) === value);
    }

    return true;
  };
 
  return (
    <>
      <PaymentReminderDialog
        open={showPaymentReminder}
        onClose={() => setShowPaymentReminder(false)}
      
      />
            
   <Grid container>
   <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className='header-container'>
     {/* <Box title='Intutrack'  > */}
      <Grid container>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
              { mobileView ? (
                 
            <div style={{    marginTop: "8px",
              width: "80px",
              display: "inline-flex"}}>
          <SideNav items={mobileNavItems} brandUrl={getLogo(logoUrl)} />
              </div>
              ) : ('')
              }
           
            {/* logo */}
              {logo()}
              {
                !showNarcissism ? (<div className='logo-text'>
                  <span style={{fontSize: '1.5rem', fontWeight: '600', color: 'rgb(107, 114, 128)'}}>{platformName}</span><br/>
                  <small>Powered by Intugine</small>
                  </div>) : ''
              }
              
            </Grid>

            {mobileView ? '' :
             (
          // web view
          <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>

         
     <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            // color: theme.palette.common.white,
          }}
        >
          {navItems.map((item) => {
            // Render dropdown menu for items with dropdown property
            if (item.dropdown && item.dropdown_items) {
              const isDropdownActive = item.dropdown_items?.some((d) => isRouteActive(d.path));
              return (
                <React.Fragment key={item.label}>
                  <MuiIconButton 
                    onClick={(e) => handleDropdownOpen(e, item.id)} 
                    size="small" 
                    id={item.label.toLowerCase()} 
                    sx={{ 
                      '&:hover': { 
                        borderRadius: '8px',
                        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%)',
                        transform: 'translateY(-1px)',
                        boxShadow: '0 2px 8px rgba(102, 126, 234, 0.15)',
                      },
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '4px',
                      transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                      position: 'relative',
                    }} 
                    className={`custom-hover nav-items navbar-dropdown-button ${isDropdownActive ? 'active-navbar-item' : ''}`}
                    aria-current={isDropdownActive ? 'page' : undefined}
                  >
                    {item.label}
                    <ChevronDown 
                      style={{ 
                        marginLeft: '4px', 
                        fontSize: '16px', 
                        transition: 'transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                        transform: Boolean(dropdownAnchorEl[item.id]) ? 'rotate(180deg)' : 'rotate(0deg)'
                      }} 
                    />
                  </MuiIconButton>
                  <MuiMenu
                    anchorEl={dropdownAnchorEl[item.id]}
                    open={Boolean(dropdownAnchorEl[item.id])}
                    onClose={() => handleDropdownClose(item.id)}
                    MenuListProps={{
                      'aria-labelledby': item.label.toLowerCase(),
                    }}
                    className="navbar-dropdown-menu"
                    PaperProps={{
                      className: 'navbar-dropdown-menu',
                      sx: {
                        borderRadius: '12px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.08)',
                        border: '1px solid rgba(0, 0, 0, 0.08)',
                        padding: '8px 0',
                        minWidth: '200px',
                        mt: 1,
                        '& .MuiMenuItem-root': {
                          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                        },
                      },
                    }}
                    TransitionProps={{
                      timeout: 200,
                    }}
                    transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                  >
                    {item.dropdown_items.map((dropdownItem) => (
                      (() => {
                        const isDropdownItemActive = isRouteActive(dropdownItem.path);
                        return (
                      <MenuItem 
                        key={dropdownItem.id}
                        onClick={() => {
                          navigate(dropdownItem.path);
                          handleDropdownClose(item.id);
                        }}
                        className={`navbar-dropdown-menu-item ${isDropdownItemActive ? 'active-navbar-item' : ''}`}
                        aria-current={isDropdownItemActive ? 'page' : undefined}
                        sx={{
                          padding: '10px 20px',
                          margin: '2px 8px',
                          borderRadius: '8px',
                          fontSize: '14px',
                          fontWeight: 500,
                          color: 'rgb(55, 65, 81)',
                          position: 'relative',
                          overflow: 'hidden',
                          '&::before': {
                            content: '""',
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            height: '100%',
                            width: '3px',
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            transform: 'scaleY(0)',
                            transition: 'transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                          },
                          '&:hover': {
                            background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%)',
                            color: 'rgb(79, 70, 229)',
                            transform: 'translateX(4px)',
                            boxShadow: '0 2px 8px rgba(102, 126, 234, 0.15)',
                            '&::before': {
                              transform: 'scaleY(1)',
                            },
                          },
                          '&:active': {
                            transform: 'translateX(2px) scale(0.98)',
                            background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.12) 0%, rgba(118, 75, 162, 0.12) 100%)',
                          },
                        }}
                      >
                        {dropdownItem.label}
                      </MenuItem>
                        );
                      })()
                    ))}
                  </MuiMenu>
                </React.Fragment>
              );
            }
            // Render regular menu item
            const isActive = isRouteActive(item.path);
            return (
              <MuiIconButton 
                key={item.label} 
                onClick={() => navigate(item.path)} 
                size="small" 
                id={item.label.toLowerCase()} 
                sx={{ '&:hover': { borderRadius: '10%' } }} 
                className={`custom-hover nav-items ${isActive ? 'active-navbar-item' : ''}`}
                aria-current={isActive ? 'page' : undefined}
              >
                {item.label}
              </MuiIconButton>
            );
          })}
          <MuiIconButton onClick={handleClick} size="small" id="bell" className="custom-hover">
            <Bell/>
          </MuiIconButton>
        
          {showMenuCard && (
            <MuiIconButton onClick={handleClickMenu} size="small" sx={{ ml: 4 }} id="card">
              <Menu
              // color={theme.palette.common.white}
              />
            </MuiIconButton>
          )}
          <MuiIconButton
            disableRipple
            sx={{
              // ml: 4,
              marginRight: '24px',
            }}
            onClick={handleClickLogout}
            id="profile"
          >
            <Avatar
              src=""
              sx={{
                marginRight: 0.5,
                height: '32px',
                width: '32px',
              }}
            >
              {/* {initialsAvatar} */}
            </Avatar>
            <ChevronDown
            //  color={theme.palette.common.white}
            />
          </MuiIconButton>
        </Box>
     <LogoutCard open={Boolean(logAnchorEl)} onClose={handleLogClose} anchorEl={logAnchorEl} handleStorageChange={handleStorageChange} />
        {Boolean(menuAnchorEl) && (
          <MenuCard
            open={Boolean(menuAnchorEl)}
            onClose={handleMenuClose}
            anchorEl={menuAnchorEl}
            menuCardData={menuCardData}
          />
        )}
        </Grid>
            )
            }
            {/* end of web view */}
        </Grid>
      {/* </Box> */}

      </Grid>
      </Grid>
 
    </>
   
  );
};

export default Navbar; 